"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
var _reactRedux = require("react-redux");
var _authentication = require("../../../../actions/authentication");
var _view = require("../../../../actions/view");
var _selectors = require("./selectors");
var _FormContainer = require("./FormContainer");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    initialEmail: (0, _selectors.viewStateEmailSelector)(state),
    error: (0, _selectors.restoreErrorSelector)(state),
    status: (0, _selectors.restoreStatusSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    restore(email, source) {
      dispatch((0, _authentication.restore)({
        email,
        source
      }));
    },
    changeView(view) {
      dispatch((0, _view.changeView)(view));
    }
  };
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FormContainer.FormContainer);